import { Col, Row, Button, Layout } from 'antd';
import React from 'react';

class NotFound extends React.Component {
  render() {
    return (
      <Layout
        style={{
          minHeight: '100vh',
          backgroundImage: `url(${require('../../images/logistics-default-bg.jpg')})`,
          backgroundSize: 'auto 100%',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <Row style={{ height: '100vh' }} type='flex' justify='space-around' align='middle'>
          <Col xs={24} style={{ textAlign: 'center' }}>
            <h1 style={{ color: 'white', fontSize: 30 }}>404 Helaas</h1>
            <h2 style={{ color: 'white', fontSize: 20 }}>De pagina lijkt niet te bestaan.</h2>
            <p>
              <a href={'/'}>
                <Button>Ga terug naar Home</Button>
              </a>
            </p>
          </Col>
        </Row>
      </Layout>
    );
  }
}

export default NotFound;
